"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HomeGreenIcon = (props) => {
    return (react_1.default.createElement("svg", { className: props.size, viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#17C873" }),
        react_1.default.createElement("path", { d: "M10.6667 17.3333V13.3333H13.3334V17.3333H16.6667V12H18.6667L12 6L5.33337 12H7.33337V17.3333H10.6667Z", fill: "white" })));
};
exports.default = HomeGreenIcon;
